import { render, staticRenderFns } from "./PointsCard.vue?vue&type=template&id=4e812088&scoped=true&"
import script from "./PointsCard.vue?vue&type=script&lang=js&"
export * from "./PointsCard.vue?vue&type=script&lang=js&"
import style0 from "./PointsCard.vue?vue&type=style&index=0&id=4e812088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e812088",
  null
  
)

export default component.exports